"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Action;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.isfunction"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _ActionText = _interopRequireDefault(require("../styled/ActionText"));
var _renderTitle = _interopRequireDefault(require("../utils/renderTitle"));
var _targets = require("../constants/targets");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function Action(_ref) {
  var children = _ref.children,
    action = _ref.action,
    actionTarget = _ref.actionTarget,
    isDisabled = _ref.isDisabled,
    testId = _ref.testId;
  var handleOnClick = function handleOnClick(event) {
    if (isDisabled) {
      event.preventDefault();
      return;
    }
    if ((0, _lodash["default"])(action)) {
      event.preventDefault();
      action(event);
    }
  };
  var renderAsButtonProps = _objectSpread({}, (0, _lodash["default"])(action) && {
    type: 'button',
    as: 'button'
  });
  return /*#__PURE__*/_react["default"].createElement(_ActionText["default"], _extends({
    tabIndex: 0
  }, renderAsButtonProps, {
    "aria-disabled": isDisabled
  }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ACTION")), _defineProperty({}, actionTarget && 'target', "".concat(actionTarget)), _defineProperty({}, (0, _lodash["default"])(action) ? 'onClick' : 'href', action), {
    title: (0, _renderTitle["default"])(children),
    isDisabled: isDisabled,
    onClick: handleOnClick
  }), children);
}
Action.propTypes = {
  testId: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  action: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  actionTarget: _propTypes["default"].oneOf([_targets.BLANK, _targets.SELF, _targets.PARENT, _targets.TOP]),
  isDisabled: _propTypes["default"].bool
};
Action.defaultProps = {
  testId: 'LABEL',
  children: undefined,
  action: undefined,
  actionTarget: _targets.SELF,
  isDisabled: false
};